import { useMemo } from 'react';
import { authService, UserRole } from '../services/authService';

/**
 * Hook para gerenciar permissões do usuário baseado nos roles
 */
export const usePermissions = () => {
  const userRoles = useMemo(() => authService.getUserRoles(), []);

  const hasRole = (role: UserRole): boolean => {
    return authService.hasRole(role);
  };

  const hasAnyRole = (roles: UserRole[]): boolean => {
    return authService.hasAnyRole(roles);
  };

  const isAdmin = (): boolean => {
    return authService.isAdmin();
  };

  const isPartner = (): boolean => {
    return authService.isPartner();
  };

  const isUser = (): boolean => {
    return authService.isUser();
  };

  const isMaster = (): boolean => {
    return authService.isMaster();
  };

  const canAccessFleet = (): boolean => {
    // Apenas Partner pode acessar a tela de frota
    return hasAnyRole(['ROLE_DEALER']);
  };

  const canAccessDashboard = (): boolean => {
    // Apenas Partner pode acessar o dashboard
    return hasAnyRole(['ROLE_DEALER']);
  };

  const canAccessHome = (): boolean => {
    // Apenas User pode acessar a home (emissão de apólice)
    return hasAnyRole(['ROLE_USER']);
  };

  const canAccessFleetListingAdmin = (): boolean => {
    // Apenas Admin pode acessar a listagem admin
    return hasAnyRole(['ROLE_ADMIN']);
  };

  const canAccessBoletosAdmin = (): boolean => {
    // Apenas Admin pode acessar a gestão de boletos
    return hasAnyRole(['ROLE_ADMIN']);
  };

  const canAccessSelectDealer = (): boolean => {
    // Apenas Master pode acessar a tela de seleção de concessionária
    return hasAnyRole(['ROLE_MASTER']);
  };

  return {
    userRoles,
    hasRole,
    hasAnyRole,
    isAdmin,
    isPartner,
    isUser,
    isMaster,
    canAccessFleet,
    canAccessDashboard,
    canAccessHome,
    canAccessFleetListingAdmin,
    canAccessBoletosAdmin,
    canAccessSelectDealer
  };
};
